(function() {
  var PhoneNumber,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  PhoneNumber = (function() {
    function PhoneNumber(countryNameAbbr, countryCode, nationalDestinationCode, number) {
      this.valid = __bind(this.valid, this);
      this.countryNameAbbr = countryNameAbbr;
      this.countryCode = countryCode;
      this.nationalDestinationCode = nationalDestinationCode;
      this.number = number;
      this.isMobile = null;
    }

    PhoneNumber.prototype.valid = function(isValid) {
      return this.valid = isValid;
    };

    return PhoneNumber;

  })();

  module.exports = PhoneNumber;

}).call(this);
